import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <AppSection />
        <FaqSection />
        <TopicsSection />
        <CardsSection />
        <CommentsSection />
        <UpdatesSection />
        <FeaturesSection />
        <IndexSection />
        <CarouselSection />
        <RankingSection />
        <MediaSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}